import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { useGameContext } from "../../../game/GameContext/GameContext";
import Input from "../../../ui/Input/Input";
import Label from "../../../ui/Label/Label";
import { InputImageWrapper } from "../../../ui/Input/Input.styled";
import { InputWithLabelContainer } from "../../../game/GameContainer/GameContainer.styled";
import Icon from "../../../ui/Icon/Icon";
var ProfitOnWin = function () {
    var _a = useGameContext(), payout = _a.payout, betAmount = _a.betAmount;
    var getProfitOnWin = useMemo(function () {
        var totalOnWin = betAmount * parseFloat(payout);
        var profitOnWin = totalOnWin - betAmount;
        return profitOnWin.toFixed(4);
    }, [payout, betAmount]);
    return (_jsxs(InputWithLabelContainer, { children: [_jsx(Label, { children: "Profit on Win" }), _jsx(Input, { type: "number", variant: "default", value: String(getProfitOnWin), readOnly: true, onChange: function () { return null; }, rightContent: _jsx(InputImageWrapper, { children: _jsx(Icon, { cdn: "coins/usdt.png" }) }) })] }));
};
ProfitOnWin.displayName = "ProfitOnWin";
export default ProfitOnWin;
//# sourceMappingURL=ProfitOnWin.js.map